import {
	a as e,
	c as t,
	d as n,
	f as r,
	l as i,
	n as a,
	o,
	p as s,
	r as c,
	s as l,
	t as u,
	u as d,
} from "./cart-surface-operations-DDPgeARZ.js";
import {
	i as f,
	n as p,
	o as m,
	r as h,
	t as g,
} from "./cart-add-intercept-L_Xl4fqj.js";
(() => {
	if (window.DifraxCartDrawerLoaded) return;
	window.DifraxCartDrawerLoaded = !0;
	let _ = `[data-cart-drawer]`,
		v = `[data-cart-drawer-remove]`,
		y = `[data-cart-drawer-quantity-input]`,
		b = `[data-cart-drawer-coupon]`,
		x = `[data-cart-drawer-coupon-status]`,
		S = `[data-cart-drawer-recommendations]`,
		C = `[data-cart-drawer-recommendations-track]`,
		w = `[data-cart-drawer-undo-action]`,
		T = null,
		E,
		D = () => {
			window.clearTimeout(E), (E = void 0);
		},
		O = (e) => {
			let [t, n] = A(e);
			return !t || !n ? e.clientWidth : n.offsetLeft - t.offsetLeft;
		},
		k = (e) => [...e.querySelectorAll(`.product-slider__slide`)],
		A = (e) => k(e).filter((e, t) => t % 2 == 0),
		j = (e) => {
			let t = A(e);
			if (!t.length) return 0;
			let n = 0,
				r = 1 / 0;
			return (
				t.forEach((t, i) => {
					let a = Math.abs(t.offsetLeft - e.scrollLeft);
					a < r && ((r = a), (n = i));
				}),
				n
			);
		},
		M = (e, t) => {
			e.querySelectorAll(`[data-cart-drawer-recommendations-dot]`).forEach(
				(e, n) => {
					let r = n === t;
					e.classList.toggle(`is-active`, r),
						e.setAttribute(`aria-current`, r ? `true` : `false`);
				},
			);
		},
		N = (e) => {
			let t = e.querySelector(C),
				n = e.querySelector(`[data-cart-drawer-recommendations-prev]`),
				r = e.querySelector(`[data-cart-drawer-recommendations-next]`);
			if (!t || !n || !r) return;
			let i = t.scrollWidth - t.clientWidth,
				a = n.closest(`.product-slider__controls`);
			a && (a.hidden = i <= 1),
				(n.disabled = t.scrollLeft <= 1),
				(r.disabled = i <= 1 || t.scrollLeft >= i - 1),
				M(e, j(t));
		},
		P = (e, t) => {
			let n = e.querySelector(`[data-cart-drawer-recommendations-dots]`);
			if (!n) return;
			let r = A(t);
			n.replaceChildren(),
				(n.hidden = r.length <= 1),
				!(r.length <= 1) &&
					r.forEach((e, r) => {
						let i = document.createElement(`button`);
						(i.className = `cart-drawer__recommendations-dot`),
							(i.type = `button`),
							(i.dataset.cartDrawerRecommendationsDot = ``),
							i.setAttribute(`aria-label`, `${r + 1}`),
							i.addEventListener(`click`, () => {
								t.scrollTo({ behavior: `smooth`, left: e.offsetLeft });
							}),
							n.append(i);
					});
		},
		F = (e) => {
			if (e.dataset.cartDrawerRecommendationsInitialized === `true`) return;
			let t = e.querySelector(C),
				n = e.querySelector(`[data-cart-drawer-recommendations-prev]`),
				r = e.querySelector(`[data-cart-drawer-recommendations-next]`);
			!t ||
				!n ||
				!r ||
				((e.dataset.cartDrawerRecommendationsInitialized = `true`),
				P(e, t),
				n.addEventListener(`click`, () => {
					t.scrollBy({ behavior: `smooth`, left: -O(t) });
				}),
				r.addEventListener(`click`, () => {
					t.scrollBy({ behavior: `smooth`, left: O(t) });
				}),
				t.addEventListener(`scroll`, () => N(e), { passive: !0 }),
				t.addEventListener(`keydown`, (e) => {
					(e.key !== `ArrowLeft` && e.key !== `ArrowRight`) ||
						(e.preventDefault(),
						t.scrollBy({
							behavior: `smooth`,
							left: O(t) * (e.key === `ArrowLeft` ? -1 : 1),
						}));
				}),
				window.addEventListener(`resize`, () => N(e)),
				window.requestAnimationFrame(() => N(e)));
		},
		I = (e = document) => {
			e.querySelectorAll?.(S).forEach(F);
		},
		L = !1,
		R = 0,
		z = () => (L ? R : window.scrollY),
		B = () => {
			let e = z();
			return () => {
				if (L) {
					(R = e), (document.body.style.top = `-${e}px`);
					return;
				}
				window.scrollTo(0, e);
			};
		},
		V = () => {
			L ||
				((L = !0),
				(R = window.scrollY),
				(document.body.style.position = `fixed`),
				(document.body.style.top = `-${R}px`),
				(document.body.style.left = `0`),
				(document.body.style.right = `0`),
				(document.body.style.width = `100%`),
				document.documentElement.classList.add(`cart-drawer-open`));
		},
		H = () => {
			if (!L) return;
			let e = R;
			(L = !1),
				document.documentElement.classList.remove(`cart-drawer-open`),
				(document.body.style.position = ``),
				(document.body.style.top = ``),
				(document.body.style.left = ``),
				(document.body.style.right = ``),
				(document.body.style.width = ``),
				window.scrollTo(0, e);
		},
		U = (e) =>
			!(e instanceof HTMLElement) ||
			!e.isConnected ||
			e === document.body ||
			e === document.documentElement ||
			e.id === `MainContent` ||
			e.closest(`[data-cart-drawer]`) ||
			(`disabled` in e && e.disabled)
				? !1
				: typeof e.focus == `function`,
		W = (e) => {
			if (U(e))
				try {
					e.focus({ preventScroll: !0 });
				} catch {
					e.focus();
				}
		};
	class G {
		abortController;
		content;
		couponForm;
		couponInput;
		couponRemove;
		couponReveal;
		couponStatus;
		checkoutCodeInput;
		checkoutForm;
		checkoutVisibilityObserver;
		drawer;
		panel;
		pendingCheckoutCodeRemove;
		pendingCheckoutCode;
		pendingCheckoutCodeValue;
		primaryCheckout;
		stickyCheckout;
		stickyCheckoutAction;
		undo;
		undoAction;
		undoStatus;
		liveRegion;
		previousFocus;
		recommendationState;
		constructor(e, t = null) {
			(this.drawer = e),
				(this.panel = e.querySelector(`[role="dialog"]`)),
				(this.content = e.querySelector(`[data-cart-drawer-content]`)),
				(this.couponForm = e.querySelector(`[data-cart-drawer-coupon-form]`)),
				(this.couponInput = e.querySelector(`[data-cart-drawer-coupon-input]`)),
				(this.couponReveal = e.querySelector(
					`[data-cart-drawer-coupon-reveal]`,
				)),
				(this.couponRemove = e.querySelector(
					`[data-cart-drawer-coupon-remove]`,
				)),
				(this.couponStatus = e.querySelector(x)),
				(this.pendingCheckoutCodeRemove = e.querySelector(
					`[data-cart-drawer-pending-checkout-code-remove]`,
				)),
				(this.pendingCheckoutCode = e.querySelector(
					`[data-cart-drawer-pending-checkout-code]`,
				)),
				(this.pendingCheckoutCodeValue = e.querySelector(
					`[data-cart-drawer-pending-checkout-code-value]`,
				)),
				(this.checkoutForm = e.querySelector(
					`[data-cart-drawer-checkout-form]`,
				)),
				(this.checkoutCodeInput = e.querySelector(
					`[data-cart-drawer-checkout-code]`,
				)),
				(this.primaryCheckout = e.querySelector(
					`[data-cart-drawer-primary-checkout]`,
				)),
				(this.stickyCheckout = e.querySelector(
					`[data-cart-drawer-sticky-checkout]`,
				)),
				(this.stickyCheckoutAction = e.querySelector(
					`[data-cart-drawer-sticky-checkout-action]`,
				)),
				(this.undo = e.querySelector(`[data-cart-drawer-undo]`)),
				(this.undoAction = e.querySelector(w)),
				(this.undoStatus = e.querySelector(`[data-cart-drawer-undo-status]`)),
				(this.liveRegion = e.querySelector(`[data-cart-drawer-live-region]`)),
				(this.checkoutVisibilityObserver = null),
				(this.abortController = null),
				(this.previousFocus = null),
				(this.recommendationState = t),
				(this.handleClick = this.handleClick.bind(this)),
				(this.handleChange = this.handleChange.bind(this)),
				(this.handleKeydown = this.handleKeydown.bind(this)),
				(this.handleCouponReveal = this.handleCouponReveal.bind(this)),
				(this.handleCouponSubmit = this.handleCouponSubmit.bind(this)),
				(this.handleCouponRemove = this.handleCouponRemove.bind(this)),
				(this.handlePendingCheckoutCodeRemove =
					this.handlePendingCheckoutCodeRemove.bind(this)),
				(this.handleCheckoutSubmit = this.handleCheckoutSubmit.bind(this)),
				(this.handleStickyCheckout = this.handleStickyCheckout.bind(this)),
				e.addEventListener(`click`, this.handleClick),
				e.addEventListener(`change`, this.handleChange),
				e.addEventListener(`keydown`, this.handleKeydown),
				this.couponReveal?.addEventListener(`click`, this.handleCouponReveal),
				this.couponForm?.addEventListener(`submit`, this.handleCouponSubmit),
				this.couponRemove?.addEventListener(`click`, this.handleCouponRemove),
				this.pendingCheckoutCodeRemove?.addEventListener(
					`click`,
					this.handlePendingCheckoutCodeRemove,
				),
				this.checkoutForm?.addEventListener(
					`submit`,
					this.handleCheckoutSubmit,
				),
				this.stickyCheckoutAction?.addEventListener(
					`click`,
					this.handleStickyCheckout,
				),
				this.restorePendingCheckoutCode(),
				this.renderRemovedLineNotice(),
				this.initStickyCheckout(),
				I(e),
				window.DifraxProductTiles?.init(e),
				this.loadAutomaticRecommendations();
		}
		get sectionId() {
			return this.drawer.dataset.sectionId;
		}
		get afterAddToCart() {
			return this.drawer.dataset.afterAddToCart || `cart_drawer`;
		}
		get cartType() {
			return this.drawer.dataset.cartType || `drawer`;
		}
		initStickyCheckout() {
			!this.content ||
				!this.primaryCheckout ||
				!this.stickyCheckout ||
				((this.checkoutVisibilityObserver = new IntersectionObserver(
					([e]) => {
						let t = this.content.getBoundingClientRect(),
							n =
								this.primaryCheckout.getBoundingClientRect().bottom > t.bottom;
						this.setStickyCheckoutVisible(e.intersectionRatio < 1 && n);
					},
					{ root: this.content, threshold: 1 },
				)),
				this.checkoutVisibilityObserver.observe(this.primaryCheckout));
		}
		setStickyCheckoutVisible(e) {
			(this.stickyCheckout.hidden = !e),
				this.primaryCheckout.toggleAttribute(`aria-hidden`, e),
				e
					? this.primaryCheckout.setAttribute(`tabindex`, `-1`)
					: this.primaryCheckout.removeAttribute(`tabindex`);
		}
		handleStickyCheckout() {
			this.primaryCheckout?.click();
		}
		handleClick(e) {
			if (e.target.closest(`[data-cart-drawer-close]`)) {
				this.close();
				return;
			}
			if (e.target.closest(w)) {
				this.restoreRemovedLine();
				return;
			}
			let t = o();
			if (e.target.closest(`[data-cart-drawer-checkout-link]`) && t) {
				e.preventDefault(), this.goToCheckoutUrl(t);
				return;
			}
			let n = e.target.closest(v);
			if (n) {
				this.updateLine(Number.parseInt(n.dataset.cartLine, 10), 0);
				return;
			}
			let r = e.target.closest(`[data-cart-drawer-quantity-change]`);
			if (!r) return;
			let i = Number.parseInt(r.dataset.cartLine, 10),
				a = Number.parseInt(r.dataset.cartQuantity, 10),
				s = Number.parseInt(r.dataset.cartDrawerQuantityChange, 10);
			this.updateLine(i, Math.max(1, a + s));
		}
		handleChange(e) {
			let t = e.target.closest(y);
			if (!t) return;
			let n = Number.parseInt(t.dataset.cartLine, 10),
				r = Number.parseInt(t.dataset.cartQuantity, 10),
				i = Number.parseInt(t.value, 10);
			if (!Number.isFinite(i)) {
				t.value = `${r}`;
				return;
			}
			let a = Math.max(1, i);
			(t.value = `${a}`), a !== r && this.updateLine(n, a);
		}
		handleKeydown(e) {
			if (e.key === `Escape`) {
				this.close();
				return;
			}
			e.key === `Enter` &&
				e.target.matches(y) &&
				(e.preventDefault(), e.target.blur());
		}
		handleCouponReveal() {
			this.revealCouponForm();
		}
		handleCouponSubmit(e) {
			e.preventDefault(),
				this.updateCoupon(this.couponInput?.value.trim() || ``);
		}
		handleCouponRemove() {
			this.updateCoupon(``);
		}
		handlePendingCheckoutCodeRemove() {
			if (!e()) {
				this.updateCoupon(``);
				return;
			}
			a(),
				this.syncCheckoutCodeInput(``),
				this.drawer
					.querySelector(b)
					?.classList.remove(`is-pending-checkout-code`),
				this.couponInput && (this.couponInput.value = ``),
				this.pendingCheckoutCodeRemove &&
					(this.pendingCheckoutCodeRemove.hidden = !0),
				this.pendingCheckoutCode && (this.pendingCheckoutCode.hidden = !0),
				this.pendingCheckoutCodeValue &&
					(this.pendingCheckoutCodeValue.textContent = ``),
				this.showCouponMessage(``, !1),
				this.couponRemove || this.revealCouponForm();
		}
		handleCheckoutSubmit(e) {
			let t = o();
			t && (e.preventDefault(), this.goToCheckoutUrl(t));
		}
		open(e) {
			(this.previousFocus = e || document.activeElement),
				V(),
				(this.drawer.hidden = !1),
				window.requestAnimationFrame(() => {
					this.drawer.classList.add(`is-open`), this.panel?.focus();
				});
		}
		close() {
			return (
				D(),
				(T = null),
				this.renderRemovedLineNotice(),
				this.drawer.classList.contains(`is-open`)
					? (this.drawer.classList.remove(`is-open`),
						H(),
						W(this.previousFocus),
						new Promise((e) => {
							window.setTimeout(() => {
								this.drawer.classList.contains(`is-open`) ||
									(this.drawer.hidden = !0),
									e();
							}, 180);
						}))
					: ((this.drawer.hidden = !0),
						H(),
						W(this.previousFocus),
						Promise.resolve())
			);
		}
		async openFresh(e, t = null) {
			let n = B(),
				r = await this.refreshSection(!1, t);
			return n(), r.open(e), r.restoreRecommendationState(), r;
		}
		async openRendered(e, t, n = null) {
			if (!e) {
				let e = await this.openFresh(t, n);
				return e.syncAddedItemCount(), e;
			}
			let r = new DOMParser().parseFromString(e, `text/html`).querySelector(_);
			if (!r) {
				let e = await this.openFresh(t, n);
				return e.syncAddedItemCount(), e;
			}
			this.drawer.replaceWith(r);
			let i = new G(r, n);
			return (
				(window.DifraxCartDrawer.controller = i),
				i.syncAddedItemCount(),
				i.open(t),
				i.restoreRecommendationState(),
				i
			);
		}
		restoreRecommendationState() {
			let e = this.recommendationState;
			if (!e) return;
			let t = this.drawer.querySelector(S),
				n = t?.querySelector(C);
			!t ||
				t.hidden ||
				!n ||
				((this.recommendationState = null),
				window.requestAnimationFrame(() => {
					(n.scrollLeft = e.scrollLeft), N(t);
					let r = t.querySelector(
							`[data-cart-recommendation-card][data-product-id="${e.productId}"]`,
						),
						i = r?.querySelector(`[data-product-tile-quick-add]`);
					(i?.disabled
						? r?.querySelector(
								`[data-cart-recommendation-variant], [data-product-tile-title-link]`,
							)
						: i
					)?.focus({ preventScroll: !0 }),
						this.liveRegion &&
							(this.liveRegion.textContent =
								`${e.addedMessage} ${e.productTitle}`.trim());
				}));
		}
		syncAddedItemCount() {
			let e = Number(this.drawer.getAttribute(`data-cart-item-count`));
			if (Number.isFinite(e)) {
				let t = { item_count: e };
				n(e), c(t, `product-add`);
			}
		}
		async updateLine(e, t) {
			if (!Number.isFinite(e)) return;
			let n = t === 0 ? this.readRemovedLine(e) : null;
			this.abortController?.abort();
			let r = new AbortController();
			(this.abortController = r), this.setPending(!0);
			try {
				let i = await u({
					currentRoot: this.drawer,
					rootSelector: _,
					sectionId: this.sectionId,
					eventSource: `cart-drawer`,
					line: e,
					quantity: t,
					signal: r.signal,
					prepareRoot: (e) => {
						e.removeAttribute(`hidden`), e.classList.add(`is-open`);
					},
				});
				if (!i.ok) throw Error(i.message);
				n && (D(), (T = { line: n, state: `removed` }));
				let a = new G(i.root);
				if (((window.DifraxCartDrawer.controller = a), n)) {
					a.focusUndoAction();
					let e = T;
					E = window.setTimeout(() => {
						if (T !== e) return;
						let t = window.DifraxCartDrawer?.controller;
						t?.undo?.contains(document.activeElement) && t.panel?.focus(),
							(T = null),
							t?.renderRemovedLineNotice(),
							(E = void 0);
					}, 3e3);
				}
			} catch (e) {
				e.name !== `AbortError` && console.warn(`Unable to update cart`, e);
			} finally {
				r.signal.aborted || this.setPending(!1);
			}
		}
		readRemovedLine(e) {
			let t = [...this.drawer.querySelectorAll(v)].find(
				(t) => Number.parseInt(t.dataset.cartLine, 10) === e,
			);
			if (!t) return null;
			let n = Number.parseInt(t.dataset.cartQuantity, 10),
				r = String(t.dataset.cartVariantId || ``).trim();
			if (!r || !Number.isFinite(n) || n < 1) return null;
			let i = {};
			try {
				let e = JSON.parse(t.dataset.cartProperties || `{}`);
				e && typeof e == `object` && !Array.isArray(e) && (i = e);
			} catch {
				i = {};
			}
			let a = String(t.dataset.cartSellingPlanId || ``).trim();
			return {
				properties: i,
				quantity: n,
				...(a ? { sellingPlanId: a } : {}),
				variantId: r,
			};
		}
		renderRemovedLineNotice({ focus: e = !1 } = {}) {
			if (!this.undo) return;
			if (!T) {
				this.undo.hidden = !0;
				return;
			}
			let t = T.state === `error`;
			(this.undo.hidden = !1),
				this.undo.classList.toggle(`is-error`, t),
				this.undoStatus &&
					(this.undoStatus.textContent = t
						? this.drawer.dataset.cartLineRestoreErrorMessage
						: this.drawer.dataset.cartLineRemovedMessage),
				this.undoAction && (this.undoAction.hidden = t),
				e &&
					window.requestAnimationFrame(() => {
						t
							? (this.undoStatus?.setAttribute(`tabindex`, `-1`),
								this.undoStatus?.focus())
							: this.undoAction?.focus();
					});
		}
		focusUndoAction() {
			this.renderRemovedLineNotice({ focus: !0 });
		}
		async restoreRemovedLine() {
			if (!T || T.state !== `removed`) return;
			D();
			let e = T.line;
			this.setPending(!0);
			try {
				let n = await t({
					currentRoot: this.drawer,
					rootSelector: _,
					sectionId: this.sectionId,
					eventSource: `cart-drawer-undo`,
					properties: e.properties,
					quantity: e.quantity,
					sellingPlanId: e.sellingPlanId,
					variantId: e.variantId,
					prepareRoot: (e) => {
						e.removeAttribute(`hidden`), e.classList.add(`is-open`);
					},
				});
				if (!n.ok) throw Error(n.message);
				T = null;
				let r = new G(n.root);
				(window.DifraxCartDrawer.controller = r),
					r.announce(r.drawer.dataset.cartLineRestoredMessage),
					r.focusRestoredLine(n.restoredLineKey);
			} catch (t) {
				(T = { line: e, state: `error` }),
					this.renderRemovedLineNotice({ focus: !0 }),
					console.warn(`Unable to restore cart line`, t);
			} finally {
				this.setPending(!1);
			}
		}
		announce(e) {
			this.liveRegion && (this.liveRegion.textContent = String(e || ``));
		}
		focusRestoredLine(e) {
			let t = [...this.drawer.querySelectorAll(`[data-cart-drawer-line-item]`)]
				.find((t) => t.dataset.cartLineKey === e)
				?.querySelector(`h3 a`);
			window.requestAnimationFrame(() => t?.focus());
		}
		async updateCoupon(t) {
			this.setPending(!0);
			try {
				let n = await r({
						currentRoot: this.drawer,
						rootSelector: _,
						couponSelector: b,
						sectionId: this.sectionId,
						eventSource: `cart-drawer`,
						code: t,
						prepareRoot: (e) => {
							e.removeAttribute(`hidden`), e.classList.add(`is-open`);
						},
					}),
					i =
						(n.root || this.drawer) === this.drawer
							? this
							: new G(n.root || this.drawer);
				if (((window.DifraxCartDrawer.controller = i), !n.ok)) {
					if (n.reason === `invalid_coupon` && t) {
						i.setPending(!0);
						let e = await s(t, i.drawer.dataset.couponErrorMessage);
						i.setPending(!1),
							e.ok
								? (i.showPendingCheckoutCode(t, e.checkoutUrl),
									i.scrollToSummary())
								: (a(),
									i.revealCouponForm({ focus: !1 }),
									i.showCouponMessage(e.message, !0));
						return;
					}
					i.revealCouponForm({ focus: !1 }), i.showCouponMessage(n.message, !0);
					return;
				}
				n.removed && e()
					? i.restorePendingCheckoutCode()
					: (!n.removed &&
							!i.couponRemove &&
							n.appliedCode &&
							i.showAppliedCouponCode(n.appliedCode, n.discountValue),
						i.showCouponMessage(
							n.removed ? `` : i.drawer.dataset.couponSuccessMessage,
							!1,
						),
						n.removed ? i.revealCouponForm() : i.scrollToSummary());
			} catch (e) {
				this.showCouponMessage(e.message, !0),
					console.warn(`Unable to update coupon code`, e);
			} finally {
				this.setPending(!1);
			}
		}
		async refreshSection(e = !1, t = null) {
			let n = B(),
				r = await l({
					currentRoot: this.drawer,
					rootSelector: _,
					sectionId: this.sectionId,
					prepareRoot: e
						? (e) => {
								e.removeAttribute(`hidden`), e.classList.add(`is-open`);
							}
						: void 0,
				});
			if ((n(), !r.ok)) throw Error(r.message);
			let i = new G(r.root, t);
			return (window.DifraxCartDrawer.controller = i), i;
		}
		async loadAutomaticRecommendations() {
			let e = this.drawer.querySelector(S);
			if (
				!e ||
				e.dataset.cartDrawerRecommendationsMode !== `automatic` ||
				e.dataset.cartDrawerRecommendationsLoaded === `true`
			)
				return;
			let t = e.dataset.cartDrawerRecommendationsProductId;
			if (!(!t || !this.sectionId)) {
				e.dataset.cartDrawerRecommendationsLoaded = `true`;
				try {
					let n = new URL(window.location.href),
						r = new URL(n.href);
					r.pathname = `${i()}recommendations/products`;
					let a = [`preview_theme_id`, `pb`, `key`, `_fd`, `oseid`],
						o = new URLSearchParams();
					for (let e of a) {
						let t = n.searchParams.get(e);
						t && o.set(e, t);
					}
					(r.search = ``),
						o.forEach((e, t) => {
							r.searchParams.set(t, e);
						}),
						r.searchParams.set(`section_id`, this.sectionId),
						r.searchParams.set(`product_id`, t);
					let s = await fetch(r.toString(), {
						credentials: `same-origin`,
						headers: { Accept: `text/html` },
					});
					if (!s.ok) throw Error(`Unable to load recommendations`);
					let c = await s.text(),
						l = new DOMParser()
							.parseFromString(c, `text/html`)
							.querySelector(S);
					if (!l || l.hidden) {
						e.hidden = !0;
						return;
					}
					e.replaceWith(l),
						(l.hidden = !1),
						I(this.drawer),
						window.Difrax?.sectionLifecycle?.runAll?.(l, {
							reason: `cart-drawer:recommendations`,
						}),
						window.DifraxProductTiles?.init(l),
						this.restoreRecommendationState();
				} catch (t) {
					(e.hidden = !0),
						console.warn(`Unable to load cart drawer recommendations`, t);
				}
			}
		}
		setPending(e) {
			this.drawer.querySelectorAll(`button, input`).forEach((t) => {
				t.toggleAttribute(`aria-busy`, e), (t.disabled = e);
			});
		}
		showCouponMessage(e, t = !1) {
			let n = this.drawer.querySelector(x);
			n && ((n.textContent = e || ``), n.classList.toggle(`is-error`, !!t));
		}
		scrollToSummary() {
			let e = this.drawer.querySelector(`[data-cart-drawer-summary]`);
			!this.content ||
				!e ||
				window.requestAnimationFrame(() => {
					let t = this.content.getBoundingClientRect().top,
						n = e.getBoundingClientRect().top,
						r = window.matchMedia?.(`(prefers-reduced-motion: reduce)`).matches;
					this.content.scrollTo({
						behavior: r ? `auto` : `smooth`,
						top: Math.max(0, this.content.scrollTop + n - t),
					});
				});
		}
		showPendingCheckoutCode(e, t = ``) {
			let n = d(e, t);
			if (!n) return;
			this.syncCheckoutCodeInput(n),
				this.drawer.querySelector(b)?.classList.add(`is-pending-checkout-code`);
			let r = this.drawer.querySelector(`[data-cart-drawer-coupon-label]`);
			r && (r.hidden = !0),
				this.couponInput && (this.couponInput.value = n),
				this.couponForm && (this.couponForm.hidden = !0),
				this.couponReveal?.setAttribute(`hidden`, ``),
				this.couponReveal?.setAttribute(`aria-expanded`, `false`),
				this.pendingCheckoutCodeRemove &&
					(this.pendingCheckoutCodeRemove.hidden = !1),
				this.pendingCheckoutCodeValue &&
					(this.pendingCheckoutCodeValue.textContent = n),
				this.pendingCheckoutCode && (this.pendingCheckoutCode.hidden = !1),
				this.showCouponMessage(
					this.drawer.dataset.checkoutCodePendingMessage ||
						`Code toegevoegd. Deze wordt toegepast bij het afrekenen.`,
					!1,
				);
		}
		showAppliedCouponCode(e, t = ``) {
			let n = String(e || ``).trim();
			if (!n) return;
			a(), this.syncCheckoutCodeInput(``);
			let r = this.drawer.querySelector(`[data-cart-drawer-coupon-label]`),
				i = r?.textContent?.trim() || ``;
			r && (r.hidden = !0),
				this.couponForm && (this.couponForm.hidden = !0),
				this.couponReveal?.setAttribute(`hidden`, ``),
				this.couponReveal?.setAttribute(`aria-expanded`, `false`),
				this.pendingCheckoutCodeValue &&
					(this.pendingCheckoutCodeValue.textContent = [
						i,
						n,
						String(t || ``).trim(),
					]
						.filter(Boolean)
						.join(` · `)),
				this.pendingCheckoutCode && (this.pendingCheckoutCode.hidden = !1);
		}
		restorePendingCheckoutCode() {
			let t = e(),
				n = o();
			t && n && this.showPendingCheckoutCode(t, n);
		}
		syncCheckoutCodeInput(e) {
			if (!this.checkoutCodeInput) return;
			let t = String(e || ``).trim();
			(this.checkoutCodeInput.value = t),
				t
					? (this.checkoutCodeInput.name = `checkout[reduction_code]`)
					: this.checkoutCodeInput.removeAttribute(`name`);
		}
		goToCheckoutUrl(e) {
			let t = new URL(String(e || ``), window.location.href);
			[`http:`, `https:`].includes(t.protocol) &&
				(window.location.href = t.toString());
		}
		revealCouponForm({ focus: e = !0 } = {}) {
			this.couponForm &&
				((this.couponForm.hidden = !1),
				this.couponReveal?.setAttribute(`aria-expanded`, `true`),
				this.couponReveal?.setAttribute(`hidden`, ``),
				e && this.couponInput?.focus());
		}
	}
	let K = () => {
		if (window.DifraxCartDrawer?.controller)
			return window.DifraxCartDrawer.controller;
		let e = document.querySelector(_);
		if (!e) return null;
		let t = new G(e);
		return (window.DifraxCartDrawer.controller = t), t;
	};
	window.DifraxCartDrawer = {
		controller: null,
		handleAfterAdd({ cart: e, sectionHtml: t } = {}) {
			let r = K(),
				a = p();
			if (!r || !a) return !1;
			n(e?.item_count), e && c(e, `product-add`);
			let o = h(a);
			return o === `checkout`
				? ((window.location.href = `${i()}checkout`), !0)
				: o === `cart_page`
					? ((window.location.href = `${i()}cart`), !0)
					: (r.openRendered(t).catch((e) => {
							console.warn(`Unable to open cart drawer`, e);
						}),
						!0);
		},
		openRendered(e, t, n = null) {
			return K()?.openRendered(e, t, n);
		},
		open(e) {
			K()?.openFresh(e);
		},
		close() {
			return K()?.close();
		},
	};
	let q = K();
	document.addEventListener(`cart:open`, () => {
		K()?.openFresh();
	}),
		document.addEventListener(`submit`, async (e) => {
			let t = e.target;
			if (!g(t) || t.closest(`[data-product-detail]`) || !f(p())) return;
			e.preventDefault();
			let n = K();
			try {
				await m(t, {
					onPending: (e) => n?.setPending(e),
					openDrawer: async ({ sectionHtml: e }) => {
						await K()?.openRendered(e);
					},
				});
			} catch (e) {
				console.warn(`Unable to add product`, e);
			}
		}),
		document.addEventListener(`click`, (e) => {
			if (!e.target.closest(`[data-cart-link]`)) return;
			let t = K();
			t?.cartType === `drawer` &&
				(e.metaKey ||
					e.ctrlKey ||
					e.shiftKey ||
					e.altKey ||
					(e.preventDefault(), t.openFresh()));
		}),
		q && (window.DifraxCartDrawer.controller = q);
})();
